<app-slide-overlay-header [isInboundShare]="true" [title]="title()" icon="docs">
  <ng-container right-side-button>
    @if (canViewContent) {
      <app-button
        (pressed)="viewContent()"
        class="page-button-more"
        size="large"
        type="icon"
        [tp]="hasContent ? translations.viewDocumentTp : translations.documentWithNoContentTp"
      >
        <mat-icon [class.red]="!hasContent">visibility</mat-icon>
      </app-button>
    }
    <app-button
      (pressed)="downloadContent()"
      class="page-button-more"
      size="large"
      type="icon"
      [tp]="hasContent ? translations.downloadDocumentTp : translations.documentWithNoContentTp"
    >
      <mat-icon [class.red]="!hasContent">download</mat-icon>
    </app-button>
  </ng-container>
</app-slide-overlay-header>
<app-slide-overlay-content #slideOverlayContent>
  <ng-template
    [overlay-menu-tab]="overlayTabEnum.DETAILS"
    appSlideOverlayMenuItem
    overlay-menu-icon="info"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.DETAILS).title"
  >
    <app-form-field-group [name]="mainInformationText">
      <app-edit-document-main-details
        [formGroup]="formGroup"
        [fileExtension]="fileExtension"
        (clickOnName)="onNameClick()"
        [hasContent]="true"
        [isEditing]="false"
        [documentTypesOptions]="documentTypesOptions()"
      ></app-edit-document-main-details>
    </app-form-field-group>
  </ng-template>
  <ng-template
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.ATTACHED_TO).isEnabled"
    [overlay-menu-show-edit-button]="false"
    [overlay-menu-show-save-button]="false"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.ATTACHED_TO).title"
    [overlay-menu-indicator]="element()?.attachedTo?.length"
    [overlay-menu-tab]="overlayTabEnum.ATTACHED_TO"
    appSlideOverlayMenuItem
    overlay-menu-icon="attach_file"
  >
    <article class="field-group-container no-padding-bottom">
      <app-attachments-table
        [isInboundShared]="true"
        [attachments]="selectedAttachments()"
      ></app-attachments-table>
    </article>
  </ng-template>
</app-slide-overlay-content>
